/* eslint-disable @typescript-eslint/no-empty-function */
import 'common/assets/style/index';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import { sentryStart } from 'common/utils/sentry';
// 因上游问题，暂时单独引用
import { msDialogPop } from 'msComponents';
import msComponents from 'msComponents';
import { PiniaVuePlugin } from 'pinia';
import pinia from 'common/stores/index';
// 引入业务属性原子化能力
import msAtom from 'msAtom';
import requestManager from 'common/plugins/request/requestManager';
// 已建议刘思进行优化，将create初始化方法包装至install中，并在install中将实例挂载到window上
// window.MsAtom = msAtom.create({
//   defaultUrl: '/error',
// });
// 引入新AB插件
import { useNewAB } from 'common/utils/newABtest';

// 项目数据流入口
import { initBaseStorage } from 'common/stores/storage';
initBaseStorage();
import { msSessionStorage } from '@common/utils/cache';
// 换肤处理
import updateTheme from 'common/plugins/adaptTheme';
// 根据url上token做免登陆，种到本地，后续如果迁移了登录页应去掉
import 'common/entry/seedBaseInfo';
// 加载项目主接口获取基础信息
import runBaseApi from 'common/entry/fetchBaseApi';
// 广告触达
import adReach from 'common/plugins/adReach';
// UBS数据采集初始化
import ubsData from 'common/plugins/ubsData';
// 神策埋点
import sensors from 'common/plugins/sensors';
// 反欺诈脚本
import mat from 'common/plugins/mat';
// 全局挂载辅助工具
import helperTools from 'common/plugins/mounted';
import { reportLogin } from 'common/plugins/mounted/logPack';

// 注入广播监听方法
import 'common/helper/observers';

import Vconsole from 'vconsole';
import { isTestHideConsole } from 'common/utils/common';
// 引入rem
// import './util/remUtil';

import loading from '@common/components/skeleton-loading/loading';
import loadingDir from '@common/components/skeleton-loading/directive';
import { cookieSetUser, getCookie } from '@common/stores/cookie';
import airTag from '@common/plugins/airTag';
import myPerformance from 'common/utils/myPerformance';
import Viewer from 'v-viewer';
import 'viewerjs/dist/viewer.css';

Vue.use(airTag, {
  enable: true,
  runtime: true,
});

Vue.use(loading);
Vue.use(PiniaVuePlugin);
Vue.use(msComponents);
// 因上游问题，暂时单独注册
Vue.component('MsDialogPop', msDialogPop);
// 是否可按需同步加载，不依赖Vue
Vue.use(adReach);
Vue.use(sensors);
Vue.use(ubsData);
Vue.use(helperTools);
Vue.use(msAtom);
Vue.use(Viewer, {
  defaultOptions: {
    // 全局配置
    inline: false,
    button: true,
    navbar: true,
    title: [
      0,
      (image, imageData) => `${image.alt} (${imageData.naturalWidth} × ${imageData.naturalHeight})`,
    ],
    toolbar: {
      zoomIn: 1,
      zoomOut: 1,
      oneToOne: 4,
      reset: 4,
      prev: 0,
      play: 0,
      next: 0,
      rotateLeft: 1,
      rotateRight: 1,
      flipHorizontal: 1,
      flipVertical: 1,
    },
  },
});

requestManager.init();

window?.MsAtom?.setOptions({
  defaultUrl: `/dlindex?channel=${msSessionStorage.get(
    'PUBLIC_CHANNEL',
  )}&productCode=${msSessionStorage.get('PUBLIC_PRODUCTCODE')}`,
});

Vue.prototype.$EventBus = new Vue();
Vue.config.productionTip = false;

if (process.env?.NODE_ENV !== 'production' && !isTestHideConsole()) {
  new Vconsole();
}
const startApp = () => {
  myPerformance.startApp();
  new Vue({
    router,
    pinia,
    render: (h) => h(App),
  }).$mount('#app');
};
const whiteList = [
  '/npublic/demo',
  '/npublic/loanGuide',
  '/npublic/safe/checkMobile',
  '/npublic/modifyLoginPwd/verifyBankCard',
  '/npublic/safe/modifyMobileIdcard',
  '/npublic/setNewLoginPwd',
  '/npublic/statuteCase',
  '/npublic/overdueImpact',
  '/npublic/page-protocol',
  '/npublic/downloadGuide',
  '/npublic/downQrCode',
  '/npublic/accountManagement/harmony',
  '/npublic/guideDownApp',
  '/npublic/mslogin',
  '/npublic/appAuthRiskControl',
  '/dlreg',
  '/personInfo/browser',
  '/npublic/privacyfile',
  '/npublic/downloadPage',
];
if (document.addEventListener) {
  document.addEventListener(
    'DOMContentLoaded',
    async (_) => {
      document.body.addEventListener('touchstart', (_) => {}, false);
      document.removeEventListener('DOMContentLoaded', (_) => {}, false);
      // 此时开始进行基础接口请求
      await runBaseApi({ whiteList });
      updateTheme();
      useNewAB();
      sentryStart(Vue, router);
      // 注册userId
      reportLogin();
      Vue.use(mat);
      startApp();
    },
    false,
  );
}
